<template>
  <div class="card-grid-resource">
    <div class="card-grid-resource__row grid__row grid__row--justify--center">
      <div
        v-for="(card, idx) in cards"
        :key="idx"
        class="card-grid-resource__column grid__column grid__column--12 grid__column--breakpoint--5--6 grid__column--breakpoint--9--4"
      >
        <component
          :is="card.data.to ? 'router-link' : 'div'"
          :to="card.data.to ? card.data.to : undefined"
          class="card-grid-resource__card"
        >
          <component
            :is="getCardComponent(card.type)"
            v-bind="card.data"
            @edit="$emit('edit', card)"
            @delete="$emit('delete', card)"
            @shareSuccuss="$emit('shareSuccuss')"
          />
        </component>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineComponent, defineProps, PropType, defineEmits } from 'vue'

import CardHole from '@base/components/CardHole/CardHole.vue'
import CardEvent from '@base/components/CardEvent/CardEvent.vue'
import CardListingCourse from '@base/components/CardListingCourse/CardListingCourse.vue'
import CardListingEvent from '@base/components/CardListingEvent/CardListingEvent.vue'
import CardResourceGallery from '@base/components/CardResourceGallery/CardResourceGallery.vue'
import CardResourceText from '@base/components/CardResourceText/CardResourceText.vue'
import CardResourceVideo from '@base/components/CardResourceVideo/CardResourceVideo.vue'

import { Card, CardType } from '@base/_types/Card'

defineComponent({
  name: 'CardGridResource',
  components: {
    CardHole,
    CardEvent,
    CardListingCourse,
    CardListingEvent,
    CardResourceGallery,
    CardResourceText,
    CardResourceVideo
  }
})

const props = defineProps({
  cards: {
    type: Array as PropType<Card[]>,
    required: true
  }
})

const emit = defineEmits(['edit', 'delete', 'shareSuccuss'])

const getCardComponent = (type: CardType) => {
  switch (type) {
    case CardType.CardEvent:
      return CardEvent
    case CardType.CardHole:
      return CardHole
    case CardType.CardListingCourse:
      return CardListingCourse
    case CardType.CardListingEvent:
      return CardListingEvent
    case CardType.CardResourceGallery:
      return CardResourceGallery
    case CardType.CardResourceText:
      return CardResourceText
    case CardType.CardResourceVideo:
      return CardResourceVideo
  }
}

const isSmallCard = (index: number) => {
  let isSmall = false
  const remainder = (index + 1) % 5

  if (remainder === 1 || remainder === 2 || remainder === 3) {
    isSmall = true
  }

  return isSmall
}
</script>

<style lang="scss" scoped>
.card-grid-resource {
  &__card {
    display: block;
    margin-bottom: calc(var(--grid--gutter-width) / 2);
    margin-top: calc(var(--grid--gutter-width) / 2);
  }
}
</style>
